import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TechAppointmentComponent } from './tech-appointment.component';
import { ConfirmInfoComponent } from './confirm-info/confirm-info.component';
import { DeactivateGuard } from '../../shared/guards/candeactivate';

const routes: Routes = [
  {
      path: '',
      component: TechAppointmentComponent,
      canDeactivate:[DeactivateGuard]
  },
  {
    path: 'confirm',
    component: ConfirmInfoComponent
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TechAppointmentRoutingModule { }
